import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import {
  loadRedpacketHomeCompletion,
  loadRedpacketConfigCompletion,
  loadRedpacketResultCompletion,
  receiveRedpacketCouponCompletion,
  loadRedpacketNoticeCompletion,
} from '../../actions';

export function* watchLoadRedpacketHome() {
  yield takeEvery('LOAD_REDPACKET_HOME', function*() {
    const options = {
      url: `/api/packetRain/lives`,
    };
    const result = yield call(app.httpFetch, options);

    yield put(loadRedpacketHomeCompletion(result.error, result.data));
  });
}

export function* watchLoadRedpacketConfig() {
  yield takeEvery('LOAD_REDPACKET_CONFIG', function*() {
    const options = {
      url: '/api/packetRain/getPacketRainList',
    };
    const result = yield call(app.httpFetch, options);

    yield put(loadRedpacketConfigCompletion(result.error, result.data));
  });
}

export function* watchLoadRedpacketResult() {
  yield takeEvery('LOAD_REDPACKET_RESULT', function*({
    id,
    key,
    score,
    couponId,
    fromUid,
  }) {
    let url = `/api/packetRain/play/${id}/${score + key + couponId}`;
    if (fromUid) {
      url += `?fromUid=${fromUid}`;
    }

    const options = { url };
    const result = yield call(app.httpFetch, options);

    yield put(loadRedpacketResultCompletion(result.error, result.data));
  });
}

export function* watchReceiveRedpacketCoupon() {
  yield takeEvery('RECEIVE_REDPACKET_COUPON', function*() {
    const options = {
      url: '/api/packetRain/coupon',
    };
    const result = yield call(app.httpFetch, options);

    yield put(receiveRedpacketCouponCompletion(result.error, result.data));
  });
}

export function* watchLoadRedpacketNotice() {
  yield takeEvery('LOAD_REDPACKET_NOTICE', function*() {
    const options = {
      url: '/api/packetRain/index',
    };
    const result = yield call(app.httpFetch, options);

    yield put(loadRedpacketNoticeCompletion(result.error, result.data));
  });
}

export default function* redpacketSaga() {
  yield all([
    fork(watchLoadRedpacketHome),
    fork(watchLoadRedpacketConfig),
    fork(watchLoadRedpacketResult),
    fork(watchReceiveRedpacketCoupon),
    fork(watchLoadRedpacketNotice),
  ]);
}
